import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import Stack from '@mui/material/Stack';
import EmptyScreeners from './EmptyScreeners';

function Screeners() {
  const [listData, setListData] = useState<any[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    fetch('/profile/screeners')
      .then((resp) => {
        if (!resp.ok) {
          throw new Error('Unable to load screeners');
        }
        return resp.json();
      })
      .then((data) => {
        if (isMounted) {
          setListData(data || []);
        }
      })
      .catch(() => {
        if (isMounted) {
          setError('Unable to load screeners');
          setListData([]);
        }
      });

    return () => {
      isMounted = false;
    };
  }, []);

  function updatelistAPI(id) {
    const url = "/screener/" + id;
    return fetch(url, { method: 'DELETE' }).then((resp) => {
      if (!resp.ok) {
        throw new Error('Unable to delete screener');
      }
      return resp.json();
    });
  }

  function updateList(e, item) {
    e.preventDefault();
    const list = (listData || []).filter(i => i.id !== item.id);
    updatelistAPI(item.id).catch(() => {});
    return setListData(list);
  }

  if (!listData) {
    return (
      <div className="py-4 border-bottom">
        <p className="clearfix">
          <p><strong>Stock Screens</strong></p>
          <div>Loading stock screens...</div>
        </p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="py-4 border-bottom">
        <p className="clearfix">
          <p><strong>Stock Screens</strong></p>
          <div>{error}</div>
        </p>
      </div>
    );
  }

  if (listData.length === 0) {
    return <EmptyScreeners />;
  }

  return (
    <div className="py-4 border-bottom">
      <p className="clearfix">
       <p><strong>Stock Screens</strong></p>
          <div className="table-responsive">
            <table className="table table-striped table-sm">
              <tbody>
                { listData.map((item =>
                  <tr key={item.id}>
                    <td>{item.name}</td>
                    <td>
                      <form>
                        <Stack direction="row" spacing={2}>
                          <Button href={"/screener/" + item.id} size="small" variant="outlined" startIcon={<SearchIcon />}>View</Button>
                          <Button size="small" onClick={(e) => updateList(e, item) } variant="outlined" startIcon={<DeleteIcon />}>Delete</Button>
                        </Stack>
                      </form>
                    </td>
                  </tr>
                )) }
              </tbody>
            </table>
          </div>
      </p>
    </div>
  );
}

export default Screeners;
